// import { appendErrors, useFormContext } from "react-hook-form";
import {Modal} from 'react-bootstrap'
const ActionModal =({
modalBody,
onHide,
onClick,
show,
modalHeading,
sessionButton,
actionButton,
logmeOut,
activeSession,
submit
}) => {
// const {formState: { errors } } = useFormContext();
return(
  
<Modal show={show} onHide={onHide} backdrop="static">

     <div className="p-3 rounded-20 modal-content">
     <Modal.Title><h5 className="font-weight-bold text-left px-3">{modalHeading}</h5></Modal.Title>
     <Modal.Body>{modalBody}</Modal.Body>
     <div className="row">
     {submit?"":<button type="button" style={{display: actionButton}} className="mx-4 px-4 btn btn-sm btn-primary" onClick={onClick}>
        OK
     </button>}
     {logmeOut?<>
     <button type="button" style={{display: sessionButton}} className="col-4 m-4 btn btn-sm btn-secondary" onClick={logmeOut}>
        Log me out
     </button>
     <button type="button" style={{display: sessionButton}} className="col-5 ml-0 mt-4 mb-4 btn btn-sm btn-success" onClick={onClick}>
        Keep me signed in
     </button>
     </>:""}
     </div>
     </div>

</Modal>
  )
  }
  export default ActionModal;
